export default __webpack_public_path__ + "static/media/dezal.13ea582a.jpg";